import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { BsLock, BsEye, BsEyeSlash } from 'react-icons/bs';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login } from '../store/slices/authSlice';
import { FaRegCircleUser } from 'react-icons/fa6';

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((s) => s.auth);

  const [form, setForm] = useState({ username: '', password: '' });
  const [formErrors, setFormErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setFormErrors((fe) => ({ ...fe, [e.target.name]: '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!form.username.trim()) errors.username = "Nom d'utilisateur requis";
    if (!form.password.trim()) errors.password = 'Mot de passe requis';
    if (Object.keys(errors).length) { setFormErrors(errors); return; }
    const result = await dispatch(login({ username: form.username.trim(), password: form.password.trim() }));
    if (result.meta.requestStatus === 'fulfilled') navigate('/dashboard');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#faf9f7', display: 'flex', flexDirection: 'column' }}>
      <div style={{ backgroundColor: '#8b1512', padding: '16px 0', textAlign: 'center' }}>
        <h4 className="text-white m-0" style={{ letterSpacing: '2px', fontFamily: 'serif' }}>
          MINISTÈRE CATHOLIQUE MISERICORDE
        </h4>
      </div>

      <Container className="d-flex flex-column align-items-center justify-content-center" style={{ flex: 1, paddingTop: '2rem', paddingBottom: '2rem' }}>
        <img src="/logo192.png" alt="MCM Logo" style={{ width: '140px', height: '174px', marginBottom: 24 }} />

        <Card style={{ width: '100%', maxWidth: 500, border: 'none', borderRadius: 12 }} className="shadow-sm p-4">
          <h4 className="text-center fw-bold mb-4">Connexion</h4>

          {error && <Alert variant="danger" className="py-2">{error}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <div className={`d-flex align-items-center border rounded px-3 ${formErrors.username ? 'border-danger' : ''}`} style={{ height: 48 }}>
                <FaRegCircleUser size={20} className="text-secondary me-2" />
                <Form.Control type="text" name="username" placeholder="Nom d'utilisateur"
                  value={form.username} onChange={handleChange}
                  style={{ border: 'none', boxShadow: 'none', padding: 0 }} />
              </div>
              {formErrors.username && <div style={{ fontSize: 12, color: '#dc3545', marginTop: 4 }}>{formErrors.username}</div>}
            </Form.Group>

            <Form.Group className="mb-4">
              <div className={`d-flex align-items-center border rounded px-3 ${formErrors.password ? 'border-danger' : ''}`} style={{ height: 48 }}>
                <BsLock size={20} className="text-secondary me-2" />
                <Form.Control type={showPassword ? 'text' : 'password'} name="password" placeholder="Mot de passe"
                  value={form.password} onChange={handleChange}
                  style={{ border: 'none', boxShadow: 'none', padding: 0 }} />
                <span onClick={() => setShowPassword((v) => !v)} style={{ cursor: 'pointer', color: '#888', flexShrink: 0, marginLeft: 8 }}>
                  {showPassword ? <BsEyeSlash size={18} /> : <BsEye size={18} />}
                </span>
              </div>
              {formErrors.password && <div style={{ fontSize: 12, color: '#dc3545', marginTop: 4 }}>{formErrors.password}</div>}
            </Form.Group>

            <Button type="submit" disabled={loading} className="w-100 fw-bold"
              style={{ backgroundColor: '#8b1512', border: 'none', height: 48, letterSpacing: 1 }}>
              {loading ? <><Spinner size="sm" animation="border" className="me-2" />Connexion...</> : 'Se Connecter'}
            </Button>
          </Form>

          <p className="text-center fw-medium text-secondary mt-3 mb-0"
            style={{ cursor: 'pointer', fontSize: '16px' }}
            onClick={() => navigate('/forgot-password')}>
            Mot de passe oublié ?
          </p>
        </Card>
      </Container>
    </div>
  );
}
